import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=0dcc9da6&scoped=true&"
import script from "./loginForm.vue?vue&type=script&lang=ts&"
export * from "./loginForm.vue?vue&type=script&lang=ts&"
import style0 from "./loginForm.vue?vue&type=style&index=0&id=0dcc9da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc9da6",
  null
  
)

export default component.exports